<template>
  <WizardStep v-if="agencies.length" id="appointment" label="Terminvorschlag">
    
<FormKitLazyProvider config-file="true">
<FormKit
      :options="agencies"
      type="radio"
      name="agency"
      validation="required"
      label="Ort"
    />
    <div class="md:grid grid-cols-2 gap-24">
      <FormKit
        :type="'datepicker' as any"
        name="date"
        label="Datum"
        placeholder="Datum"
        help="Wählen Sie Ihr gewünschtes Datum aus"
        :disabled-days="disabledDays"
        overlay
        weekday-format="ddd"
        :week-start="1"
        :format="{ date: 'long' }"
        :min-date="minDate"
        value-locale="ch"
        validation="required"
        picker-only
      />
      <FormKit
        type="select"
        label="Uhrzeit"
        name="time"
        validation="required"
        :options="timeOptions"
      />
    </div>
</FormKitLazyProvider>

  </WizardStep>
</template>

<script setup lang="ts">
import { FormKitLazyProvider } from '@formkit/vue'
import type { FormKitNode } from '@formkit/core'
import type { FormKitOptionsItem } from '@formkit/inputs'

defineProps<{
  agencies: FormKitOptionsItem[]
}>()

function disabledDays(node: FormKitNode, date: Date) {
  // Re-implement min-date and max-date
  if (node.props.minDate && date < node.props.minDate) return true
  if (node.props.maxDate && date > node.props.maxDate) return true

  // If the date is a weekend, disable it.
  return date.getDay() === 0 || date.getDay() === 6
}

const timeOptions = computed(() => {
  const options: { value: string; label: string }[] = []

  for (let h = 8; h < 20; h++) {
    for (let m = 0; m < 60; m += 15) {
      const time = [
        h.toString().padStart(2, '0'),
        m.toString().padStart(2, '0'),
      ].join(':')
      options.push({ label: time, value: time })
    }
  }
  return options
})

const minDate = computed(() => {
  return new Date()
})
</script>
